<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CN" id="_idParaDest-3">EARTHLINGS</p>
<p class="Author">SAYAKA MURATA</p>
<p class="Trans">Translated from the Japanese by Ginny Tapley Takemori</p>
<p class="BT1stPara ParaOverride-2"><img alt="" class="_idGenObjectAttribute-1" src="image/V-1.jpg"/></p>
<p class="BT1stPara ParaOverride-1"><span class="CharOverride-2">Grove Press</span></p>
<p class="BT1stPara ParaOverride-1"><span class="CharOverride-3">New York</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 97808021570272.vue?4adf57ca